module.exports = __webpack_public_path__ + "img/wuye.426bf695.png";